module.exports = __webpack_public_path__ + "static/media/LiveView3.5999af36.webp";